import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  inviteeRegionUpdated,
  inviteeEventsUpdated,
  inviteeInvitationUpdated,
} from '../actions/invitee';
import './Admin.css';

const mapStateToProps = state => ({
  panelVisible: state.admin.panelVisible,
  adminMode: state.admin.adminMode,
  invitee: state.invitee,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { inviteeRegionUpdated, inviteeEventsUpdated, inviteeInvitationUpdated },
    dispatch
  );
}

const Region = ({ invitee, inviteeRegionUpdated }) => {
  const { region } = invitee;

  return (
    <div className="admin-list">
      <div>region:</div>
      {region === 'canada-west' ? (
        <div className="active admin-list-item">ca-west</div>
      ) : (
        <div
          className="admin-list-item"
          onClick={inviteeRegionUpdated.bind(null, 'canada-west')}
        >
          ca-west
        </div>
      )}
      {region === 'us-west' ? (
        <div className="active admin-list-item">us-west</div>
      ) : (
        <div
          className="admin-list-item"
          onClick={inviteeRegionUpdated.bind(null, 'us-west')}
        >
          us-west
        </div>
      )}
      {region === 'us-east' ? (
        <div className="active admin-list-item">us-east</div>
      ) : (
        <div
          className="admin-list-item"
          onClick={inviteeRegionUpdated.bind(null, 'us-east')}
        >
          us-east
        </div>
      )}
      {region === 'other' ? (
        <div className="active admin-list-item">other</div>
      ) : (
        <div
          className="admin-list-item"
          onClick={inviteeRegionUpdated.bind(null, 'other')}
        >
          other
        </div>
      )}
    </div>
  );
};

const Events = ({ invitee, inviteeEventsUpdated }) => {
  const { events = {} } = invitee;

  const func = inviteeEventsUpdated;

  return (
    <div className="admin-list">
      <div>events:</div>
      <div
        className={`admin-list-item ${events.ca ? 'active' : ''}`}
        onClick={func.bind(null, 'ca', events)}
      >
        ca
      </div>
      <div
        className={`admin-list-item ${events.ny ? 'active' : ''}`}
        onClick={func.bind(null, 'ny', events)}
      >
        us
      </div>
    </div>
  );
};

const Invitation = ({ invitee, inviteeInvitationUpdated }) => {
  const style = invitee.invitation_style;

  const func = inviteeInvitationUpdated.bind(null);

  return (
    <div className="admin-list">
      <div>invitation style:</div>
      <div
        className={`admin-list-item ${style === 'modern' ? 'active' : ''}`}
        onClick={func.bind(null, 'modern')}
      >
        code
      </div>
      <div
        className={`admin-list-item ${style === 'traditional' ? 'active' : ''}`}
        onClick={func.bind(null, 'traditional')}
      >
        traditional
      </div>
    </div>
  );
};

const Admin = props => {
  let view = null;
  if (props.panelVisible && props.adminMode) {
    view = (
      <div id="admin">
        <Region {...props} />
        <Events {...props} />
        <Invitation {...props} />
      </div>
    );
  }

  return view;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js